var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 13H3V15.5C3 15.9125 3.14687 16.2656 3.44062 16.5594C3.73437 16.8531 4.0875 17 4.5 17H9.25V13ZM10.75 13V17H15.5C15.9125 17 16.2656 16.8531 16.5594 16.5594C16.8531 16.2656 17 15.9125 17 15.5V13H10.75ZM9.25 11.5V7.5H3V11.5H9.25ZM10.75 11.5H17V7.5H10.75V11.5ZM3 6H17V4.49562C17 4.08187 16.8531 3.72917 16.5594 3.4375C16.2656 3.14583 15.9125 3 15.5 3H4.5C4.0875 3 3.73437 3.14688 3.44062 3.44063C3.14687 3.73438 3 4.0875 3 4.5V6Z",
    fill: "#F1001E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableView);
export default __webpack_public_path__ + "static/media/table_view.3d5c060c426568607a04f27f3573c6f8.svg";
export { ForwardRef as ReactComponent };